/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Filter module selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'
import { SEARCH_VIEW_TYPE } from './constants'

export const selectRoot = (state: State) => state?.filters

export const selectCurrentSearch = (state: State) => state?.currentSearch

export const selectCurrentSearchLocation = compose(
  (currentSearch) => currentSearch?.location,
  selectCurrentSearch
)

export const selectCurrentSearchCityName = compose(
  (currentSearch) => currentSearch?.cityName ?? '',
  selectCurrentSearchLocation
)

export const selectCurrentSearchStateName = compose(
  (currentSearch) => currentSearch?.stateName ?? '',
  selectCurrentSearchLocation
)

export const selectFilterModal = compose((state) => state?.filterModal, selectRoot)

export const selectListablesCount = compose((state) => state?.listablesCount, selectRoot)

export const selectFilters = compose((state) => state?.filters, selectRoot)

// Inspector
export const getCurrentLocation = (state: State) => {
  return state.currentSearch?.location
}

export const checkSaveSearchCreateView = (state: State) => {
  return state?.searchUI && state?.searchUI?.searchView === SEARCH_VIEW_TYPE.SAVE_SEARCH_CREATE
}

export function getCurrentLocationForSaveSearch(state: State) {
  return state?.currentSearch?.saveSearchLocation
}

// Saved Searches
const selectSavedSearchesView = (state: State) => state?.savedSearchesView

export const selectSavedSearches = compose((state) => state?.savedSearches, selectSavedSearchesView)

export const selectIsShortTermCalendarPickerOpen = compose(
  (state) => state?.isShortTermCalendarPickerOpen,
  selectFilterModal
)

export const selectIsNavbarExpanded = compose(
  (state) => state?.isNavbarExpanded,
  selectCurrentSearch
)

export const selectIsBot = (state: State) => state?.app?.bot ?? false
